import * as Three from 'three';

export const createUniforms = (noise?: Three.Texture) => ({
    iTime: { value: 0 },
    iResolution: { value: new Three.Vector3() },
    iChannel0: { value: noise },
    iMouse: { value: new Three.Vector2(0, 0) }
});
